import React, { useState } from "react";

import { CloseOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

import StyledTooltip from "../../Common/UIComponents/StyledTooltip";

import { hasPermission, permissions } from "../../../utils/Permissions";
import { buildCreateSampleSubmissionPath } from "../utils";

import { getEnvironmentFields } from "../../../actions/envAnalytics";
import { getProductFields } from "../../../actions/reports";

import "./CreateSampleModal.css";

export default function CreateSampleModal({
  onCancel, setShowSubmissionForm, setSampleCategory, heading, loadingFields,
}) {
  const [loadingButton, setLoadingButton] = useState("");
  const history = useHistory();

  const canCreateProduct = hasPermission(permissions.sampleSubmission.createProductSubmission);
  const canOnboardProduct = hasPermission(permissions.onboarding.onboardProduct);
  const product = canCreateProduct || canOnboardProduct;
  const productTooltip = product ? "" : "Please contact your admin to avail Product Services.";

  const canCreateEnvironment = hasPermission(permissions.sampleSubmission.createEnvironmentSubmission);
  const canOnboardEnvironment = hasPermission(permissions.onboarding.onboardEnvironment);
  const environment = canCreateEnvironment || canOnboardEnvironment;
  const environmentTooltip = environment ? "" : "Please contact your admin to avail Environment Services.";

  const handleOnboardingRedirect = async (category) => {
    setLoadingButton(category);
    const result = category === "environment"
      ? await getEnvironmentFields(true)
      : await getProductFields(true);
    const onboardingDone = result.success && result.fields && result.fields.length > 0;
    setLoadingButton("");
    if (onboardingDone) {
      toast.error(
        category === "environment"
          ? "You do not have access to create an Environment Sample Submission."
          : "You do not have access to create a Product Sample Submission.",
      );
    } else {
      history.push(`/onboarding/${category}`);
    }
  };

  /*
   * Earlier logic (kept below): useEffect on mount called getProductFields / getEnvironmentFields
   * to enable buttons and set tooltips from onboarding status (e.g. disable + "no access" when
   * onboarded but missing create permission).
   * Commented out: avoids API calls every time the modal opens; uses sync create/onboard checks
   * and handleOnboardingRedirect on click instead (aligned with FloatingButton).
   */
  // useEffect(() => {
  //   const checkPermissionsAndFields = async () => {
  //     // Check Product permission
  //     if (hasPermission(permissions.sampleSubmission.createProductSubmission)) {
  //       // If permission exists, enable button (no API call needed)
  //       setProduct(true);
  //       setProductTooltip("");
  //     } else {
  //       // If Permission is missing, check onboarding status
  //       const productFieldsResult = await getProductFields(true);
  //       const isOnboardingCompleted = productFieldsResult.success && productFieldsResult.fields && productFieldsResult.fields.length > 0;

  //       if (isOnboardingCompleted) {
  //         // Case 2: Onboarding is completed - Permission is not there
  //         // Disable button with message
  //         setProduct(false);
  //         setProductTooltip("You do not have access to create a Product Sample Submission.");
  //       } else if (hasRolePermission("onboard_product")) {
  //         // Case 1: Onboarding is not completed - Permission is not there
  //         // Admin/Support: Enable button (will redirect to onboarding on click)
  //         setProduct(true);
  //         setProductTooltip("");
  //       } else {
  //         // Member: Disable button with message
  //         setProduct(false);
  //         setProductTooltip("Please contact your admin to avail Product Services.");
  //       }
  //     }

  //     // Check Environment permission
  //     if (hasPermission(permissions.sampleSubmission.createEnvironmentSubmission)) {
  //       // If permission exists, enable button (no API call needed)
  //       setEnvironment(true);
  //       setEnvironmentTooltip("");
  //     } else {
  //       // If Permission is missing - check onboarding status
  //       const envFieldsResult = await getEnvironmentFields(true);
  //       const isOnboardingCompleted = envFieldsResult.success && envFieldsResult.fields && envFieldsResult.fields.length > 0;

  //       if (isOnboardingCompleted) {
  //         // Case 2: Onboarding is completed - Permission is not there
  //         // Disable button with message
  //         setEnvironment(false);
  //         setEnvironmentTooltip("You do not have access to create an Environment Sample Submission.");
  //       } else if (hasRolePermission("onboard_environment")) {
  //         // Case 1: Onboarding is not completed - Permission is not there
  //         // Admin/Support: Enable button (will redirect to onboarding on click)
  //         setEnvironment(true);
  //         setEnvironmentTooltip("");
  //       } else {
  //         // Member: Disable button with message
  //         setEnvironment(false);
  //         setEnvironmentTooltip("Please contact your admin to avail Environment Services.");
  //       }
  //     }
  //   };

  //   checkPermissionsAndFields();
  // }, []);

  // Handle product specific actions
  const handleProductClick = () => {
    if (canCreateProduct) {
      setSampleCategory("product");
      setShowSubmissionForm(true);
      setLoadingButton("product");
      history.push(buildCreateSampleSubmissionPath("product"));
    } else {
      handleOnboardingRedirect("product");
    }
  };

  // Handle environment specific actions
  const handleEnvironmentClick = () => {
    if (canCreateEnvironment) {
      setSampleCategory("environment");
      setShowSubmissionForm(true);
      setLoadingButton("environment");
      history.push(buildCreateSampleSubmissionPath("environment"));
    } else {
      handleOnboardingRedirect("environment");
    }
  };

  return (
    <Modal
      open
      closable
      centered
      footer={null}
      onCancel={onCancel}
      width="452px"
      closeIcon={<CloseOutlined className="SampleSubmissionModal__closeIcon" />}
      className="CreateSampleAlert"
    >
      <div className="CreateSampleTitle">{heading}</div>
      <div className="CreateSampleBtn">

        <StyledTooltip
          title={productTooltip}
          className="MyForm__Section_Tooltip Onboarding__Tooltip"
        >
          <Button
            type="primary"
            disabled={!product}
            onClick={handleProductClick}
            loading={loadingButton === "product" ? loadingFields : false}
          >
            Product
          </Button>
        </StyledTooltip>

        <StyledTooltip
          title={environmentTooltip}
          className="MyForm__Section_Tooltip Onboarding__Tooltip"
        >
          <Button
            type="primary"
            disabled={!environment}
            onClick={handleEnvironmentClick}
            loading={loadingButton === "environment" ? loadingFields : false}
          >
            Environment
          </Button>
        </StyledTooltip>
      </div>
    </Modal>
  );
}
